import { render } from "./dashboard_assesmen_hc.vue?vue&type=template&id=16ba69bc&scoped=true"
import script from "./dashboard_assesmen_hc.vue?vue&type=script&lang=js"
export * from "./dashboard_assesmen_hc.vue?vue&type=script&lang=js"

import "./dashboard_assesmen_hc.vue?vue&type=style&index=0&id=16ba69bc&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ba69bc"]])

export default __exports__